import 'react';
import visa from './visa.js';
import unionpay from './unionpay.js';
import troy from './troy.js';
import placeholder from './placeholder.js';
import mastercard from './mastercard.js';
import jcb from './jcb.js';
import amex from './amex.js';
import dinersclub from './dinersclub.js';
import discover from './discover.js';
import hipercard from './hipercard.js';

var index = {
  amex: amex,
  dinersclub: dinersclub,
  discover: discover,
  hipercard: hipercard,
  jcb: jcb,
  unionpay: unionpay,
  mastercard: mastercard,
  placeholder: placeholder,
  visa: visa,
  troy: troy
};

export default index;



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-payment-inputs/es/images/index.js
// module id = 969
// module chunks = 0